import { client } from "@/api/Repositories";

function groupList (data) {
  return data.map(element => {
    if (!element.is_selectable) return { header: element.name}
    else return element
  })
}

export default {
  namespaced: true,
  state: {
    materialTypes: [],
    sparePartTypes: [],
    repairStageTypes: [],
    wasteTypes: [],
    bladeDamageTypes: []
  },
  getters: {
    DAMAGE_TYPE_NAME: state => id => {
      const damage = state.bladeDamageTypes.filter(element => element.id === id)
      return damage.length > 0 ? damage[0].name : id
    }
  },
  mutations: {
    getMaterialTypes (state, data) {
      state.materialTypes = []
      state.materialTypes = data
    },
    getSparePartTypes (state, data) {
      state.sparePartTypes = []
      state.sparePartTypes = data
    },
    getRepairStageTypes (state, data) {
      state.repairStageTypes = []
      state.repairStageTypes = data
    },
    getWasteTypes (state, data) {
      state.wasteTypes = []
      state.wasteTypes = data
    },
    getBladeDamageTypes (state, data) {
      state.bladeDamageTypes = []
      state.bladeDamageTypes = data
    },
  },
  actions: {
    getMaterialTypes ({ commit }) {
      return new Promise((resolve, reject) => {
        client.get('/material-types')
          .then(response => {
            const data = response.data.data.filter(element => element.is_active)
            const list = groupList(data)
            commit('getMaterialTypes', list)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    getSparePartTypes ({ commit }) {
      return new Promise((resolve, reject) => {
        client.get('/spare-part-types')
          .then(response => {
            const data = response.data.data
            commit('getSparePartTypes', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    getRepairStageTypes ({ commit }) {
      return new Promise((resolve, reject) => {
        client.get('/repair-stage-types')
          .then(response => {
            const data = response.data.data
            const list = groupList(data)
            commit('getRepairStageTypes', list)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    getWasteTypes ({ commit }) {
      return new Promise((resolve, reject) => {
        client.get('/waste-types')
          .then(response => {
            const data = response.data.data
            commit('getWasteTypes', data)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    },
    getBladeDamageTypes ({ commit }) {
      return new Promise((resolve, reject) => {
        client.get('/blade-damage-types')
          .then(response => {
            const data = response.data.data
            const list = groupList(data)
            commit('getBladeDamageTypes', list)
            resolve(response);
          })
          .catch(error => {
            reject(error);
          })
      })
    }
  }
}
